export const MEDIA_TYPES = {
  IMAGES: 'images',
  VIDEOS: 'videos',
};

export const POPULAR_CATEGORIES = [
  { name: 'Architecture', media_type: MEDIA_TYPES.IMAGES, phrase: 'architecture' },
  { name: 'Fitness and wellness', media_type: MEDIA_TYPES.IMAGES, phrase: 'fitness and wellness' },
  { name: 'Jobs and careers', media_type: MEDIA_TYPES.IMAGES, phrase: 'jobs and careers' },
  { name: 'Seasonal and holiday', media_type: MEDIA_TYPES.IMAGES, phrase: 'seasonal and holiday' },
  { name: 'Business and finance', media_type: MEDIA_TYPES.IMAGES, phrase: 'business and finance' },
  { name: 'Food and drink', media_type: MEDIA_TYPES.IMAGES, phrase: 'food and drink' },
  { name: 'Moods and feelings', media_type: MEDIA_TYPES.IMAGES, phrase: 'moods and feelings' },
  { name: 'Special occasions', media_type: MEDIA_TYPES.IMAGES, phrase: 'special occasions' },
  { name: 'Education', media_type: MEDIA_TYPES.IMAGES, phrase: 'education' },
  { name: 'Happiness', media_type: MEDIA_TYPES.IMAGES, phrase: 'happiness' },
  { name: 'Nature and landscapes', media_type: MEDIA_TYPES.IMAGES, phrase: 'nature and landscapes' },
  { name: 'Sports and recreation', media_type: MEDIA_TYPES.IMAGES, phrase: 'sports and recreation' },
  { name: 'Family', media_type: MEDIA_TYPES.IMAGES, phrase: 'family' },
  { name: 'Healthcare and medicine', media_type: MEDIA_TYPES.IMAGES, phrase: 'healthcare and medicine' },
  { name: 'Pets and animals', media_type: MEDIA_TYPES.IMAGES, phrase: 'pets and animals' },
  { name: 'Travel destinations', media_type: MEDIA_TYPES.IMAGES, phrase: 'travel destinations' },
  { name: 'Fashion and beauty', media_type: MEDIA_TYPES.IMAGES, phrase: 'fashion and beauty' },
  { name: 'Science and technology', media_type: MEDIA_TYPES.IMAGES, phrase: 'science and technology' },
].sort((a, b) => (a.name > b.name ? 1 : -1));

export const DIVERSITY_CATEGORIES = [
  { name: 'Authenticity', media_type: MEDIA_TYPES.IMAGES, phrase: 'authenticity' },
  { name: 'Community activism', media_type: MEDIA_TYPES.IMAGES, phrase: 'community activism' },
  { name: 'Female leaders', media_type: MEDIA_TYPES.IMAGES, phrase: 'female leaders' },
  { name: 'Mental health', media_type: MEDIA_TYPES.IMAGES, phrase: 'mental health' },
  { name: 'Body positivity', media_type: MEDIA_TYPES.IMAGES, phrase: 'body positivity' },
  { name: 'Disability in sports', media_type: MEDIA_TYPES.IMAGES, phrase: 'disability in sports' },
  { name: 'Humanizing tech', media_type: MEDIA_TYPES.IMAGES, phrase: 'humanizing tech' },
  { name: 'Sustainability', media_type: MEDIA_TYPES.IMAGES, phrase: 'sustainability' },
].sort((a, b) => (a.name > b.name ? 1 : -1));

export const MAIN_PAGE_CATEGORY_PHRASE = 'adventure';
export const MAIN_PAGE_SEARCH_PARAMS = {
  searchPhrase: MAIN_PAGE_CATEGORY_PHRASE,
  mediaType: MEDIA_TYPES.IMAGES,
  pageSize: 4,
  filters: {
    excludeNudity: true,
  },
};
export const MAIN_PAGE_CATEGORY_LABEL = 'Adventure';

export const DEFAULT_PAGE_SIZE = 30;

export const ROUTES = {
  HOME: '',
  SEARCH: 'search',
  PURCHASE: 'purchase',
};

export const SORT_OPTIONS = ['best_match', 'most_popular', 'newest'];

export const ORIENTATION_OPTIONS = ['horizontal', 'vertical', 'square', 'panoramic_horizontal', 'panoramic_vertical'];

export const NUMBER_OF_PEOPLE_OPTIONS = ['none', 'one', 'two', 'group'];

export const LICENSE_TYPE_OPTIONS = ['creative', 'editorial'];

export const COLOR_OPTIONS = [
  '#E72525',
  '#F48700',
  '#ECA71D',
  '#F1F129',
  '#A9E418',
  '#06D506',
  '#1AE0E0',
  '#0BBBF5',
  '#00F',
  '#7F00FF',
  '#BF00FF',
  '#EA06B1',
  '#000000',
  '#FFFFFF',
];

export const AGE_OPTIONS = ['baby', 'child', 'teenager', 'young_adult', 'adult', 'adults_only', 'mature_adult', 'senior_adult'];

export const ETHNICITY_OPTIONS = [
  'black',
  'caucasian',
  'east_asian',
  'hispanic_latino',
  'middle_eastern',
  'mixed_race_person',
  'multiethnic_group',
  'native_american_first_nations',
  'pacific_islander',
  'south_asian',
  'southeast_asian',
];

export const RESOLUTION_OPTIONS = ['4k', 'hd'];

export const DURATION_MIN = 0;
export const DURATION_MAX = 120;
export const DURATION_STEP = 1;
export const DURATION_INITIAL_VALUE = [DURATION_MIN, DURATION_MAX];

export const FILTERS_BY_MEDIA_TYPE = {
  [MEDIA_TYPES.IMAGES]: ['sortBy', 'license', 'licenseType', 'orientations', 'numberOfPeople', 'color', 'more', 'excludeNudity'],
  [MEDIA_TYPES.VIDEOS]: ['sortBy', 'formatAvailable', 'duration', 'ageOfPeople', 'more', 'excludeNudity'],
};

export const INVALID_TOKEN_CODE = 401;

export const CREDIT_PRICES = {
  [MEDIA_TYPES.IMAGES]: {
    essentials: 1,
    signature: 3,
  },
  [MEDIA_TYPES.VIDEOS]: {
    essentials: 6,
    signature: 18,
  },
};
